import { NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuardService} from './auth/services/auth-guard.service';
import {NewPicturesComponent} from './components/views-photos/new-pictures/new-pictures.component';
import {ContradictoryAuthGuardService} from './auth/services/contradictory-auth-guard.service';
import {DirectAccessGuardService} from './auth/services/direct-access-guard.service';
import {RedirectComponent} from './components/redirect/redirect.component';
import { ModalajoutcontactComponent } from './pages/bascontact/menu/modalajoutcontact/modalajoutcontact.component';
import { SuivisPdtComponent } from './components/planDeTraitement/suivis-pdt/suivis-pdt.component';

const routes: Routes = [

    {
        path :'ajouter' , component:ModalajoutcontactComponent
    },

    {
        path: '',
        redirectTo: 'home', //home
        pathMatch: 'full',
        canActivate: [AuthGuardService],
        
    }, 

    { path: 'my-profile', loadChildren: './pages/my-profile/my-profile.module#MyProfilePageModule', canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN','ROLE_RH','ROLE_PRATICIEN','ROLE_ASSISTANTES','ROLE_FINANCIERS','ROLE_USER','ROLE_SECRETAIRES'],

        }

     },


    {
        path: 'photos-list',
        loadChildren: './pages/photos-list/photos-list.module#PhotosListPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN','ROLE_USER'],

        }
    },

    {
        path: 'viewer',
        loadChildren: './pages/viewer/viewer.module#ViewerPageModule',
        canActivate: [AuthGuardService, DirectAccessGuardService]
    },


    {
        path: 'home', loadChildren: './pages/accueil/accueil.module#AccueilPageModule',
        canActivate: [AuthGuardService]
    },


    {
        path: 'edit-photos-list',
        loadChildren: './pages/edit-photos-list/edit-photos-list.module#EditPhotosListPageModule',
        canActivate: [AuthGuardService, DirectAccessGuardService]
    },
    {
        path: 'baspremier', loadChildren: './pages/baspremier/baspremier.module#BaspremierModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN','ROLE_USER','ROLE_PRATICIEN'],

        }
    },
    {
        path: 'login', loadChildren: './auth/login/login.module#LoginPageModule',
        canActivate: [ContradictoryAuthGuardService]
    },
    {
        path: 'picturesPatient', component: NewPicturesComponent,
        canActivate: [AuthGuardService, DirectAccessGuardService]
    },

    {
        path: 'redir', component: RedirectComponent,
        canActivate: [AuthGuardService]
    }, 



    { path: 'preanalyse', loadChildren: './pages/basdiag/preanalyse/preanalyse.module#PreanalysePageModule',
        canActivate: [AuthGuardService],
        
    },
    
    { path: 'masquefacial', loadChildren: './pages/basdiag/masquefacial/masquefacial.module#MasquefacialPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        }
        
    },
    { path: 'facesourire', loadChildren: './pages/basdiag/facesourire/facesourire.module#FacesourirePageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        }
         
    },
    { path: 'occlusal', loadChildren: './pages/basdiag/occlusal/occlusal.module#OcclusalPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        }
        
    },
    { path: 'fonctionnel', loadChildren: './pages/basdiag/fonctionnel/fonctionnel.module#FonctionnelPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        }
        
    },
    { path: 'arcades', loadChildren: './pages/basdiag/arcades/arcades.module#ArcadesPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        }
        
    },
    { path: 'sourire', loadChildren: './pages/basdiag/sourire/sourire.module#SourirePageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        }
        
    },
    { path: 'profil', loadChildren: './pages/basdiag/profil/profil.module#ProfilPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        }
       
    },
    {
    path: 'profile_sourire',
    loadChildren: './pages/basdiag/profile_sourire/profile_sourire.module#ProfileSourirePageModule',
    canActivate: [AuthGuardService],
    data: {
        name: ['ROLE_ADMIN']
    }
    },

    { path: 'radio', loadChildren: './pages/basdiag/radio/radio.module#RadioPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        }
        
    },
    { path: 'pano', loadChildren: './pages/basdiag/pano/pano.module#PanoPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        }
        
    },
    { path: 'basdiagadultehome', loadChildren: './pages/basdiag/basdiagadultehome/basdiagadultehome.module#BasdiagadultehomePageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        }
         
    },

    

    {
        path: 'basdiag', loadChildren: './pages/basdiag/basdiag.module#BasdiagPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        }
    },

    { path: 'resultat', loadChildren: './pages/basdiag/resultat/resultat.module#ResultatPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        } },
    { path: 'basdiag-mini', loadChildren: './pages/basdiag-mini/basdiag-mini.module#BasdiagMiniPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        } },
    { path: 'preanalyse-mini', loadChildren: './pages/basdiag-mini/preanalyse-mini/preanalyse-mini.module#PreanalyseMiniPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        } },
    { path: 'occlusal-mini', loadChildren: './pages/basdiag-mini/occlusal-mini/occlusal-mini.module#OcclusalMiniPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        }},
    { path: 'arcades-mini', loadChildren: './pages/basdiag-mini/arcades-mini/arcades-mini.module#ArcadesMiniPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        } },
    { path: 'radio-mini', loadChildren: './pages/basdiag-mini/radio-mini/radio-mini.module#RadioMiniPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        } },
    { path: 'resultat-mini', loadChildren: './pages/basdiag-mini/resultat-mini/resultat-mini.module#ResultatMiniPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        } },
    { path: 'parametrage', loadChildren: './pages/basdiag-mini/parametrage/parametrage.module#ParametragePageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        } },

    { path: 'basdiag-enfant-mini', loadChildren: './pages/basdiagEnfant-mini/basdiag-enfant-mini/basdiag-enfant-mini.module#BasdiagEnfantMiniPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        } },
    { path: 'arcades-enfant-mini', loadChildren: './pages/basdiagEnfant-mini/arcades-mini/arcades-enfant-mini/arcades-enfant-mini.module#ArcadesEnfantMiniPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        } },
    { path: 'occlusal-enfant-mini', loadChildren: './pages/basdiagEnfant-mini/occlusal-mini/occlusal-enfant-mini/occlusal-enfant-mini.module#OcclusalEnfantMiniPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        } },
    { path: 'radio-enfant-mini', loadChildren: './pages/basdiagEnfant-mini/radio-mini/radio-enfant-mini/radio-enfant-mini.module#RadioEnfantMiniPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        } },
    { path: 'resultat-enfant-mini', loadChildren: './pages/basdiagEnfant-mini/resultat-enfant-mini/resultat-enfant-mini.module#ResultatEnfantMiniPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        } 
    },

    { path: 'resultat-enfant', loadChildren: './pages/basdiagEnfant-mini/resultat-enfant/resultat-enfant.module#ResultatEnfantPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        } 
    },

    { path: 'liste-patients', loadChildren: './pages/liste-patients/liste-patients.module#ListePatientsPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN','ROLE_USER','ROLE_PRATICIEN'],

        } 
     },

    { path: 'cephalometrie', loadChildren: './pages/cephalometrie/cephalometrie.module#CephalometriePageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        } 
     },

    { 
        path: 'q1cs', 
        loadChildren: './pages/q1cs/q1cs.module#Q1csModule', 
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN', 'ROLE_RH', 'ROLE_PRATICIEN', 'ROLE_ASSISTANTES', 'ROLE_FINANCIERS', 'ROLE_USER', 'ROLE_SECRETAIRES']
        }
    },

    { path: 'recherche-patient', loadChildren: './pages/recherche-patient/recherche-patient.module#RecherchePatientPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN','ROLE_USER','ROLE_PRATICIEN'],

        } 
     },

    { path: 'choix-bas-diag-mini', loadChildren: './pages/choix-bas-diag-mini/choix-bas-diag-mini.module#ChoixBasDiagMiniPageModule', canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        } 
     },
    { path: 'choix-bas-diag', loadChildren: './pages/choix-bas-diag/choix-bas-diag.module#ChoixBasDiagPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        } 
     },
    { path: 'parametrage-basdiag', loadChildren: './pages/basdiag/parametrage-basdiag/parametrage-basdiag.module#ParametrageBasdiagPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        } 
     },

    { path: 'basdiag-enfant', loadChildren: './pages/basdiag-enfant/basdiag-enfant.module#BasdiagEnfantPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        } 
     },
    { path: 'masquefacial-enfant', loadChildren: './pages/basdiag-enfant/masquefacial-enfant/masquefacial-enfant.module#MasquefacialEnfantPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        }  },
    { path: 'facesourire-enfant', loadChildren: './pages/basdiag-enfant/facesourire-enfant/facesourire-enfant.module#FacesourireEnfantPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        }  },
    { path: 'occlusal-enfant', loadChildren: './pages/basdiag-enfant/occlusal-enfant/occlusal-enfant.module#OcclusalEnfantPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        }  },
    { path: 'fonctionnel-enfant', loadChildren: './pages/basdiag-enfant/fonctionnel-enfant/fonctionnel-enfant.module#FonctionnelEnfantPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        }  },
    { path: 'arcades-enfant', loadChildren: './pages/basdiag-enfant/arcades-enfant/arcades-enfant.module#ArcadesEnfantPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        }  },
    { path: 'sourire-enfant', loadChildren: './pages/basdiag-enfant/sourire-enfant/sourire-enfant.module#SourireEnfantPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        }  },
    { path: 'profil-enfant', loadChildren: './pages/basdiag-enfant/profil-enfant/profil-enfant.module#ProfilEnfantPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        }  },

    { path: 'profil-sourire-enfant', loadChildren: './pages/basdiag-enfant/profil-sourire-enfant/profil-sourire-enfant.module#ProfilSourireEnfantPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        }  },
    { path: 'radio-enfant', loadChildren: './pages/basdiag-enfant/radio-enfant/radio-enfant.module#RadioEnfantPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        }  },
    { path: 'resultat-enfant-full', loadChildren: './pages/basdiag-enfant/resultat-enfant/resultat-enfant.module#ResultatEnfantPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        }  },
    { path: 'plan-de-traitement', loadChildren: './pages/plan-de-traitement/plan-de-traitement.module#PlanDeTraitementPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN'],

        }  },

            {
        path: 'suivis-pdt', component: SuivisPdtComponent,
        canActivate: [AuthGuardService]
    }, 
    { path: 'fiche-patient', loadChildren: './pages/fiche-patient/fiche-patient.module#FichePatientPageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN','ROLE_USER'],
    
        }
        },

    { path: 'messagerie', loadChildren: './pages/messagerie/messagerie.module#MessageriePageModule',
        canActivate: [AuthGuardService],
        data: {
            name: ['ROLE_ADMIN','ROLE_RH','ROLE_PRATICIEN','ROLE_ASSISTANTES','ROLE_FINANCIERS','ROLE_USER','ROLE_SECRETAIRES'],
        }
    },
    {
    path: 'access',
    loadChildren: './pages/access/access.module#AccessModule',
    canActivate: [AuthGuardService],
    data: { name: ['ROLE_SUPER_ADMIN'] }
    },

  {
    path: '**',
    loadChildren: './pages/not-found/not-found.module#NotFoundPageModule',
    canActivate: [AuthGuardService]
    },




];

// branch dev test
@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
